import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { localurl } from '../utils.js';
import { FaRegUser } from "react-icons/fa6";
import { LuEye } from "react-icons/lu";
import { WiTime4 } from "react-icons/wi";
import { FaRegFlag } from "react-icons/fa6";
import { GoTag } from "react-icons/go";

const Activity = ({ chatDetails }) => {
    const { chatId } = useParams();
    const [activity, setActivity] = useState([]);

    useEffect(() => {
        const fetchChatDetails = async () => {
            try {
                const response = await axios.get(`${localurl}/escalation/chat/activity/${chatId}`, {
                    headers: {
                        accept: "application/json",
                    },
                });
                setActivity(response.data);
            } catch (error) {
                console.error("Error fetching chat details:", error);
            }
        };

        fetchChatDetails();
    }, [chatId]);

    return (
        <div>
            <p className='font-medium text-sm text-black'>Activity Timeline</p>
            <div>
                {activity.map((activity) => (
                    <div className='flex flex-row gap-3 mt-2'>
                        <div className='p-2 border flex justify-center items-center border-gray-300 rounded-full w-6 h-6 mt-3'>
                            {activity.activity_type === "viewed" ? (
                                <span className='text-md text-black'><LuEye /></span>
                            ) : activity.activity_type === "assigned" ? (
                                <span className='text-base text-[#F97316]'><WiTime4 /></span>
                            ) : activity.activity_type === "status_changed" ? (
                                <span className="text-xs text-[#22C55E]"><GoTag /></span>
                            ) : activity.activity_type === "priority_changed" ? (
                                <span className="text-xs text-[#EF4444]"><FaRegFlag /></span>
                            ) : ("")}
                        </div>
                        <div className='mt-2 flex flex-col gap-1'>
                            <div className='flex flex-row gap-2 items-center'>
                                <div className="bg-[#EAEAEA] w-8 h-8 rounded-full flex justify-center items-center text-black">
                                    <FaRegUser />
                                </div>
                                <p>{activity.user}</p>
                                <span className="ml-1 text-xs text-gray-400">
                                    {new Date(activity.created_at).toLocaleTimeString(
                                        [],
                                        {
                                            month: "short",
                                            day: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        }
                                    )}
                                </span>
                            </div>
                            <p className='text-[#71717A] text-sm'>{activity.details}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Activity